import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import type {
  DevelopmentPaceScenarioResult,
  DevelopmentPaceScenarioFacets,
  DevelopmentPaceScenarioAggregations,
} from './types';

export interface DevelopmentPaceScenarioParams extends SearchParams {
  paceModel?: string[];
  createdBy?: string[];
  createdAt?: { start?: string; end?: string };
  updatedAt?: { start?: string; end?: string };
}

export const createDevelopmentPaceScenarioSearchAtom = () =>
  searchAtomPair<
    DevelopmentPaceScenarioResult,
    DevelopmentPaceScenarioParams,
    DevelopmentPaceScenarioFacets,
    DevelopmentPaceScenarioAggregations
  >({ href: '/queries/development_pace_scenarios' });
